// extracted by mini-css-extract-plugin
export default {"switch":"styles_switch__Ug9ib","text":"styles_text__09cBT"};